import { color, isEscape, isUpArrow, Text } from '@starrez/starryui9';
import React, { createRef, useEffect, useState } from 'react';
import styled from 'styled-components';
import { SearchInput } from '../../../../../../.starryUI/SearchInput/SearchInput';
import { IMainDirectoryListVariables, useLazyMainDirectoryListQuery } from '../../../graphql/useAllMainDirectoryListQuery';
import { strings } from '../../../localization';
import { useViewPicker } from '../context/ViewPickerContext';
import { ManageViews } from './ManageViews';
import { OrganizedViews } from './OrganizedViews';
import { ViewItemList } from './ViewItemList';
import { ViewOptions } from './ViewOptions';
import { SystemViews } from './SystemViews';

export const ViewPickerPanel = () => {
    const [searchString, setSearchString] = useState<string>('');
    const { closePicker } = useViewPicker();
    const headerRef = createRef<HTMLLIElement>();

    const variables: IMainDirectoryListVariables = {
        filter: [{ search: { like: searchString } }, { folder: { eq: false } }],
        skip: 0,
        limit: 10,
    };

    const [getData, { data, loading, error }] = useLazyMainDirectoryListQuery(variables);

    useEffect(() => {
        const header = headerRef.current;
        if (header) {
            header.focus();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleOnSearch = (searchString: string): Promise<void> => {
        return new Promise<void>((resolve) => {
            setSearchString(searchString);
            getData();
            resolve();
        });
    };

    const searchResults = data?.allMainDirectoryList?.nodes;

    const viewOptionsProps = {
        loading,
        error,
        searchString,
        searchResults,
    };

    const handleOnKeyDown = (e: React.KeyboardEvent<HTMLLIElement>) => {
        if (isEscape(e) || isUpArrow(e)) {
            e.stopPropagation();
            closePicker();
        }
    };

    return (
        <Container>
            <ViewItemList>
                <Header tabIndex={0} ref={headerRef} onKeyDown={(e) => handleOnKeyDown(e)}>
                    <Text variant="normal.bold">{strings.ViewPicker_Label_SelectView}</Text>
                </Header>
                <SearchContainer>
                    <SearchInput
                        onSearchChange={handleOnSearch}
                        placeholder={strings.ViewSearch_Label_Search}
                        searchAriaLabel={strings.ViewSearch_Label_SearchForView}
                        clearAriaLabel={strings.ViewSearch_Label_ClearSearch}
                    />
                </SearchContainer>
                <ViewOptions {...viewOptionsProps} />
                {!searchString.length && (
                    <>
                        <SystemViews />
                        <OrganizedViews />
                    </>
                )}
                <ManageViews />
            </ViewItemList>
        </Container>
    );
};

const Container = styled.div`
    width: 300px;
    background-color: ${color.StarRezBrandColors.WhiteSR};
    border: 1px solid ${color.Grey.G30};
    box-shadow: 0px 2px 30px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    margin-top: 2px;
    outline: 0;
`;

const SearchContainer = styled.li`
    border-top: 1px solid ${color.Grey.G30};
`;

const Header = styled.li`
    display: grid;
    align-items: center;
    padding: 0 16px;
    height: 40px;
    outline: 0;
    border-radius: 4px;
    border: 2px solid transparent;

    &:focus {
        border: 2px solid ${color.Blue.B80};
    }
`;
